import ajax from "@/lib/ajax";
import { formatDistance, format } from "date-fns";
let typeObj = {};
Array.prototype.$imFindIndexByKey = function(key, value) {
    let i = -1;
    if (key)
        this.forEach((item, index) => {
            if (item[key] == value) {
                i = index;
            }
        });
    return i;
};

/**
 * 返回handle 数组差集
 * @param arr
 * @param handle
 * @param key
 * @returns {*}
 */
function arrDiffSet(arr, handle, key) {
    let newhandle = [];
    handle.forEach(item1 => {
        let flag = true;
        arr.forEach(item2 => {
            if (item1[key] && item1[key] == item2[key]) {
                flag = false;
            }
        });
        if (flag) newhandle.push(item1);
    });
    return newhandle;
}

function isAssetTypeFileType(ext, type = "img") {
    if (type == "img") {
        return ["png", "jpg", "jpeg", "bmp", "gif", "webp", "psd", "svg", "tiff"].indexOf(ext.toLowerCase()) !== -1;
    } else if (type == "video") {
        return ["mp4"].indexOf(ext.toLowerCase()) !== -1;
    } else if (type == "audio") {
        return ["mp3"].indexOf(ext.toLowerCase()) !== -1;
    } else {
        return (
            [
                "tar",
                "zip",
                "rar",
                "pdf",
                "rm",
                "avi",
                "tmp",
                "xls",
                "xlsx",
                "txt",
                "doc",
                "docx",
                "wps",
                "ppt",
                "html",
                "htm",
                "css",
                "js",
                "7z",
                "mp3",
                "mp4"
            ].indexOf(ext.toLowerCase()) !== -1
        );
    }
}

/**
 * 倒计时 / 格式化
 * @param timestamp
 * @param useDistance
 */
function timeFormatFun(timestamp, useDistance) {
    let date = new Date(timestamp * 1000);
    return useDistance ? formatDistance(date, new Date()) : format(date, "yyyy-MM-dd HH:mm:ss");
}

function formatLastMessage(last_message = {}, isRealTime = true) {
    if (last_message && last_message.id) {
        let { msg_type, content, create_time } = last_message;
        let timeFormat = timeFormatFun(create_time, isRealTime);
        last_message.timeFormat = timeFormat;
    }
    return last_message;
}

/**
 *
 * @param session
 * @param isRealTime true 当前会话列表 false:历史会话列表
 * @return {*}
 */
function formatSession(session, { isRealTime = true } = {}) {
    session.last_message = formatLastMessage(session.last_message, isRealTime);
    session.user_info = session.user_info || {};
    session.user_info.avatar = session.user_info.avatar || "/im/default-user.png";
    session.isRealTime = isRealTime;
    session.tag_name = typeObj[session.tag_id];
    if (isRealTime) {
        session.draft = { html: "", text: "" };
        //    session.sort_level = setSortLevel(session);
    }
    return session;
}

//第二排序优先级：已读未回复 + 新创建  level = 2
//第三排序优先级：未读 level = 3
//第四排序优先级：已回复 level = 4
//区间内按照最后一条消息新的在上旧的在下
function setSortLevel(item) {
    if (!item.id) {
        return;
    }
    let level = -1;
    if (item.msg_unread_count == 0 && item.last_message.is_send == 0) {
        level = 2;
    } else if (item.msg_unread_count) {
        level = 3;
    } else if (item.last_message.is_send || item.last_message.is_send == null) {
        level = 4;
    }
    return { level, lastest: item.last_message.create_time || new Date() - 0 };
}

async function getRealTimeSessionList() {
    if (Object.keys(typeObj).length == 0) {
        await getTicketType();
    }
    let list = [];
    try {
        list = await ajax.get("/im/session/list");
    } catch (err) {}
    return list;
}

/**
 * 历史会话记录
 * @param page
 * @param prepage
 * @param agent_id
 * @return {Promise<Array>}
 */
async function getHistorySessionList({ page, prepage = 20, agent_id }) {
    let list = [],
        isRealTime = false;
    try {
        list = await ajax.get("/im/session/history/list", { agent_id, page, prepage });
    } catch (err) {}
    let newlist = [];
    list.forEach((item, index) => {
        item.isRealTime = isRealTime;
        newlist.push(formatSession(item, { isRealTime }));
    });
    return newlist;
}

async function updateAgentStatus(status) {
    let isSus = false;
    try {
        await ajax.post("/im/agent/status/update", { status });
        isSus = true;
    } catch (err) {}
    return isSus;
}

async function getAgentInfo() {
    let data = {};
    try {
        data = await ajax.get("/im/agent/status/get");
    } catch (err) {}
    return data;
}

async function getGroupList(agent_id) {
    let list = [];
    try {
        const data = await ajax.get("/ticket/agent/group/list", { agent_id });
        list = data.list || [];
    } catch (err) {}
    return list;
}

async function transferSession(session_id, to_group_id) {
    let isSus = false;
    try {
        isSus = await ajax.post("/im/session/transfer", { session_id, to_group_id });
    } catch (err) {}
    return isSus;
}

/**
 * @param listInfo
 * @param session_id
 * @param page
 * @param prepage
 */
async function getSessionMsgList(listInfo) {
    let prepage = 10;
    if (listInfo.status == "loading" || listInfo.status == "nomore") {
        return;
    }
    listInfo.status = "loading";
    let page = Math.ceil(listInfo.list.length / prepage);
    page = listInfo.list.length % prepage == 0 ? page : page - 1;
    page = page < 0 ? 0 : page;
    let list = [];
    try {
        // 测试 listInfo.session_id  '1572418271458978297fQ6pYSQ3n267l'
        list = await ajax.get("/im/session/message/list", { session_id: listInfo.session_id, page, prepage });
    } catch (err) {}
    // list.reverse();
    listInfo.status = list.length < prepage ? "nomore" : "loadingend";
    list = arrDiffSet(listInfo.list, list, "id"); //去重
    let newlist = [];
    list.forEach(item => newlist.push(messageFormat(item)));
    listInfo.list.unshift(...newlist);
}

async function closeSession(session_id) {
    let isSus = false;
    try {
        isSus = await ajax.post("im/session/close", { session_id });
    } catch (err) {}
    return isSus;
}

async function setReadStatus(session_id) {
    let isSus = false;
    try {
        await ajax.post("im/session/notify_checked_state", { session_id });
        isSus = true;
    } catch (err) {}
    return isSus;
}

let translateQueue = [];
let isTranslating = false;
async function translatePoll() {
    if (translateQueue.length) {
        isTranslating = true;
        let { from = "", to, content, cb } = translateQueue.shift();
        try {
            let result = await ajax.post("/language/translate", { from, to, content });
            cb({ output: result.output });
        } catch ({ code }) {
            cb({ err_code: code });
        }
        translatePoll();
    } else {
        isTranslating = false;
    }
}

/**
 * 源语言检查 目前前端尚未找到比较全面的方法 暂时不填 google自动检查的效果如何
 * @param from = ''
 * @param to
 * @param content
 * @return {Promise<string>}
 */
function translate({ from = "", to, content }, cb) {
    translateQueue.push({ from, to, content, cb });
    if (!isTranslating) {
        //开启翻译队列
        translatePoll();
    }
}

async function fetchTranslate({ from = "", to, list }) {
    let err_code,
        outputObj = {};
    try {
        let { list: outlist = [] } = await ajax.post("/language/batch/translate", { from, to, list });
        outlist.forEach(({ id, output }) => (outputObj[id] = output));
    } catch ({ code }) {
        err_code = code;
    }
    return { err_code, outputObj };
}

async function getUserInfo({ user_id, session_id }) {
    let user_info = {};
    try {
        user_info = await ajax.get("/im/user/get", session_id ? { session_id } : { user_id });
    } catch (err) {}
    return user_info;
}

async function getSearchHistoryMessageList(param) {
    let list = [];
    try {
        let message_list = await ajax.get("/im/message/search", param);
        message_list.forEach(item => {
            list.push(messageFormat(item));
        });
    } catch (err) {}

    return list;
}

async function sendAction(item) {
    let { msg_type, session_id, content } = item;
    try {
        let { msg_id } = await ajax.post("im/message/send", { content, msg_type, session_id });
        item.sending = 2;
        item.id = msg_id;
    } catch (err) {
        item.sending = 3;
    }
}

//临时写的上传 没有用
async function upload(file) {
    let { url } = await ajax.post("upload", { file });
    //测试
    url = "https://ossweb-img.qq.com/images/naruto/1.png";
    return url;
}

function trimBr(html) {
    return html
        .replace(/<div>/g, "")
        .replace(/<\/div>/g, "")
        .replace(/^(<br>)+/, "")
        .replace(/(<br>)+$/, "");
}

/**
 * 根据传参判断类型 ： string  img  file video audio
 * @param sendContent
 * @returns {{msg_type: number, content: string, file: *}}
 */
function getMsgByContent(sendContent) {
    let msg_type = "";
    let content = "";
    if (typeof sendContent == "string") {
        msg_type = 1;
        content = sendContent;
    } else if (sendContent instanceof Image) {
        content = sendContent.src;
        let ext = content.split(".").pop();
        if (isAssetTypeFileType(ext, "img")) {
            msg_type = 2;
        } else if (isAssetTypeFileType(ext, "video")) {
            msg_type = 4;
        } else if (isAssetTypeFileType(ext, "audio")) {
            msg_type = 3;
        } else {
            msg_type = 5;
        }
    }
    return { msg_type, content };
}

/*function windowTip({ content, clickcb }) {
    let nav = new window.Notification("你有一条新消息", {
        body: content,
        //        icon: headimgurl || "http://test.gbotinter.qq.com/logo.png",
        requireInteraction: false,
        renotify: false
    });
    nav.onclick = function() {
        window.focus();
        clickcb && clickcb();
    };
}*/

function robotMsgSplit(id, content, create_time) {
    //将机器人会话answer[] 拆分成消息  content[] 再拆分消息
    let children = [];
    try {
        content = JSON.parse(content);
        content.answer = content.answer ? JSON.parse(content.answer) : [];
    } catch (e) {
        content = {};
    }
    if (content.question) {
        children.push(
            messageFormat({
                //用户首发
                id: `${id}-1-1`,
                is_send: 0,
                msg_type: 1,
                content: content.question,
                create_time: create_time
            })
        );
    }
    content.answer &&
        content.answer.forEach((item, index) => {
            let { tpl_type, content } = item;
            if ([10, 11].indexOf(tpl_type) == -1) {
                content.forEach((c, key) => {
                    children.push(
                        messageFormat({
                            id: `${id}${index}${key}`,
                            is_send: 1,
                            msg_type: 10001,
                            tpl_type,
                            content: c,
                            create_time: create_time
                        })
                    );
                });
            }
        });
    return children;
}

function messageFormat(message) {
    let textContent = "",
        imgContent = "",
        answerList = [],
        children = [],
        sysText = "";

    let { id, sending, msg_type, tpl_type, content, create_time, session_id, is_send } = message;
    switch (msg_type) {
        case 0:
            sysText = content;
            break;
        case 6:
            sysText = "用户已评价";
            break;
        case 1:
            textContent = content.replace(/\n/g, "<br>");
            break;
        case 2:
            imgContent = this.message.content;
            break;
        case 1000: //筛分机器人消息
            children = robotMsgSplit(id, content, create_time);
            break;
        case 10001: //拆分机器人消息
            switch (tpl_type) {
                case 1:
                    textContent = content.text;
                    break;
                case 7: // option 附框 js处理按照热点来处理
                    let { title, question } = content;
                    textContent = title;
                    answerList = getArrayValue(question, "question_display_text");
                    break;
            }
            break;
    }
    return {
        id,
        create_time,
        sending,
        avator: "/im/dialog-default.png",
        sysText,
        answerList,
        textContent: children.length ? "-" : textContent,
        imgContent,
        children,
        msg_type, //非对话类型都按照系统消息处理
        content,
        session_id,
        translateStatus: "start",
        translateContent: "",
        is_send
    };
}

function getArrayValue(arr = [], key) {
    let list = [];
    arr.forEach(item => list.push(item[key]));
    return list;
}

async function getTicketType() {
    let obj = {};
    try {
        let { list } = await ajax.get("/ticket/type/list");
        list.forEach(item => {
            obj[item.id] = item.name;
        });
    } catch (err) {}
    typeObj = obj;
    return obj;
}

export default {
    getRealTimeSessionList,
    updateAgentStatus,
    getAgentInfo,
    formatSession,
    messageFormat,
    getGroupList,
    transferSession,
    getSessionMsgList,
    getHistorySessionList,
    closeSession,
    timeFormatFun,
    setReadStatus,
    translate,
    setSortLevel,
    getUserInfo,
    getSearchHistoryMessageList,
    sendAction,
    trimBr,
    getMsgByContent,
    formatLastMessage,
    fetchTranslate,
    //   windowTip,
    getTicketType
};
